import type { SVGProps } from 'react';

export const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 0C10.9256 0 13.5 2.57436 13.5 5.75C13.5 7.80534 12.4207 9.60736 10.7988 10.624C13.563 11.8082 15.5 14.5524 15.5 17.75C15.5 18.1642 15.1642 18.5 14.75 18.5C14.3358 18.5 14 18.1642 14 17.75C14 14.2982 11.2018 11.5 7.75 11.5C4.29822 11.5 1.5 14.2982 1.5 17.75C1.5 18.1642 1.16421 18.5 0.75 18.5C0.335786 18.5 0 18.1642 0 17.75C0 14.5527 1.93643 11.8084 4.7002 10.624C3.07873 9.60728 2 7.80504 2 5.75C2 2.57437 4.57437 0 7.75 0ZM7.75 1.5C5.40279 1.5 3.5 3.40279 3.5 5.75C3.5 8.09719 5.4028 10 7.75 10C10.0972 10 12 8.09719 12 5.75C12 3.4028 10.0972 1.5 7.75 1.5Z"
    />
  </svg>
);
